import { useEffect, useState } from "react";
import { BasicButton } from "../../theme/Component/BasicButton";
import { DocumentViewer } from "../../theme/Component/DocumentViewer";
import { ErrorList } from "../../theme/Component/ErrorList";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { _BudgetRPFactory, _single } from "../../../core/services/dataBean/EntityCatalog";
import { toast } from "react-toastify";

interface Props {
    contrato?: any;
    formData?: any;
    rpList: any;
    onChange: Function;
    eventCreate?: Function;
}

export const CreateRFDocument = ({ contrato, rpList, formData, onChange, eventCreate }: Props) => {

    const _budgetRDFactory = useDataBean(_BudgetRPFactory);

    const [documents, setDocuments] = useState<any>([]);
    const [msgList, setMsgList] = useState<any>([]);
    const [response, setResponse] = useState<any>({});
    const [tap, setTap] = useState<number>(0);

    const crearDocumento = () => {
        // console.log(formData.ContractSearched?.IDAdquisitionContract ?? null, formData.ContractSearched?.AdquisitionContractDate ?? null, formData.AccountantDate, formData.ExternalCode, rpList, formData.Description, formData.IDAccount, _single.getAccountID(), true)
        _budgetRDFactory.instance.createRP(formData.ContractSearched ? contrato.IDAdquisitionContract : null, formData.ContractSearched ? contrato.AdquisitionContractDate : null, formData.AccountantDate, formData.ExternalCode, rpList, formData.Description, formData.IDAccount, _single.getAccountID(), true).then(
            (resp: any) => {
                //console.log(resp)
                setDocuments(resp.DocumentURL);
                setResponse(resp)
                setMsgList(resp.MsgList);
                setTap(1)
            }
        ).catch(
            err => {
                toast.error(err, { autoClose: false })
            }
        )
    }

    useEffect(() => {
        onChange({
            Response: response,
            Documents: documents,
            MSGList: msgList,
        })
        if (documents.length > 0 && eventCreate) {
            const rp = {
                IDDocument: response.IDDocument,
                DocumentDate: response.DocumentDate,
                Mnemonic: response.Mnemonic,
                Consecutive: response.Consecutive,
            }
            eventCreate(rp)
        }
    }, [documents, msgList])

    return (
        <div className="row">
            {tap === 0 &&
                <div className="col-md-6 mt-4">
                    <BasicButton disable={!formData.AccountantDate} icon="ri-article-line" eventClick={crearDocumento}>Generar Registro Presupuestal</BasicButton>
                </div>
            }
            {tap === 1 &&
                <div className="col">
                    {msgList.length > 0 &&
                        <ErrorList lista={msgList} />

                    }
                    {msgList.length === 0 && documents.length > 0 &&
                        <DocumentViewer key={documents} list={documents} />
                    }
                </div>
            }
        </div>
    )
}